import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  currentLang = 'en';
  constructor(private translate: TranslateService) {
    this.currentLang = translate.currentLang;
    // translate.use('fa');
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.currentLang = this.translate.currentLang;
    request = request.clone({
      setHeaders: {
        lan: this.currentLang ? this.currentLang : 'en'
      }
    });
    return next.handle(request);
  }
}
